import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { WallboardsService } from '../../wallboards.service';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { WVData, WVMain } from '../wallboard-view.model';
import { WallboardGameSetupObj, ModuleType } from '../../wallboards.model';

@Component({
    selector: 'cv-wallboard-view-games',
    templateUrl: './wallboard-view-games.component.html',
    styleUrls: ['./wallboard-view-games.component.scss']
})
export class WallboardViewGamesComponent implements OnInit, OnDestroy {
    @Input() firstSlide: boolean;

    public wvf: WVMain;
    public wvgf: WVData;
    public gameState: WallboardGameSetupObj;
    public selectedGame: any[] = []; //GameObject[]
    public participantsInfo: any[] = [];
    private updateTimerRef: NodeJS.Timeout = null;

    public bullseyeWinners = [[], [], [], [], []];
    public milestoneWinners = [[], [], [], [], []];

    public totalParticipants = 0;
    public totalJoinedParticipants = 0;

    // Variables for pagination
    public currentPage = 0;
    public totalPages = 0;
    public pageSize = 0;
    public slideError: boolean = false;

    public isSlideDataLoading = false;

    public tableHeight;
    public metricCompleted = [];
    public uniqueMilestoneParticipantsIDs: any[];
    public MilestoneThemes: any;
    public themeSelected: any;
    public nonqualifiedParticipants: any;

    private isDestroyed: boolean = false;
    private _hasBackdrop: boolean = false;
    private _moduleKey: string = "";
    private _backgroundID: number = 0;


    get hasBackdrop(): boolean {
        return this._hasBackdrop;
    }


    get moduleKey(): string {
        return this._moduleKey;
    }

    get backgroundID(): number {
        return this._backgroundID;
    }

    get slideContainer(): JQuery<HTMLElement> {
        return $(this.mainWindow?.nativeElement);
    }

    @ViewChild('wallboardViewSlide') mainWindow: ElementRef;

    constructor(
        private service: WallboardViewService,
        public wallboardsService: WallboardsService,
        private cvApiService: CVApiService,
        private gmf: GamesService,
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.wvgf = this.service.WVGames;

        this._hasBackdrop = this.wvgf?.Slide.HasBackdrop ?? false;
        this._moduleKey = this.wvgf?.Slide.WallboardModuleDetails[0].WallboardModuleKey ?? "";
        this._backgroundID = this.wvgf?.Slide.BackgroundImageID ?? 0;


        this.wvf.RunSlide = this.firstSlide;

        this.slideContainer.css("height", "100vh");

        setTimeout(() => {
            this.tableHeight = (this.slideContainer.find(".wallboardViewSlideContentArea").height() - 132);
        }, 0);

        this.loadTypeState().then(response => {
            if (this.isDestroyed)
                return;

            this.gameState = response.Wallboard_Game_Settings;

            this.loadGames().then(async response => {
                if (this.isDestroyed)
                    return;

                // Create a list of games only (not by folder)
                this.selectedGame = await response.GameFolders.reduce<any[]>((games, folder) => { //GameObject[]
                    Array.prototype.push.apply(games, folder.Games.map(g => {
                        g.Folder = folder.FolderData;
                        return g.GameObject;
                    }));

                    return games;
                }, []);

                if (this.participantsInfo) {
                    await this.loadGamesHistory(true);
                    this.runSlide();
                }
            });
        });
    }

    ngOnDestroy(): void {
        if (this.updateTimerRef != null)
            clearInterval(this.updateTimerRef);

        this.isDestroyed = true;
    }

    public async loadTypeState() {
        let latestError;

        for (let i = 0; i < 3; i++) {
            try {
                return await this.wallboardsService.loadTypeState(ModuleType.Games, this.moduleKey, this.wvf.WallboardCreatorID);
            }
            catch (error) {
                latestError = error;
            }
        }

        this.slideError = true;
        this.wvf.SkipNextSlide = true;

        throw latestError;
    }

    public async loadGames() {
        let latestError;

        for (let i = 0; i < 3; i++) {
            try {
                return await this.wallboardsService.loadGames(this.gameState.GameID);
            }
            catch (error) {
                latestError = error;
            }
        }

        this.wvf.SkipNextSlide = true;

        throw latestError;
    }

    public async runSlide() {
        if (this.isDestroyed)
            return;

        let calculatedInterval = null;

        let verifyNextSlide = this.firstSlide == undefined && (this.wvgf.Slide.WallboardModuleDetails[0].WallboardSlideID == this.wvf.Slides[this.wvf.NextSlide].WallboardSlideID);
        let slideTimer: number;
        let slideIntervalTime: number;

        if (verifyNextSlide) {
            slideTimer = (this.wvf.Slides[this.wvf.NextSlide].SlideInterval);
            slideIntervalTime = (this.wvf.Slides[this.wvf.NextSlide].SlideInterval - 1) * 1000;
        }
        else if (this.wvf.LastSlide != null) {
            slideTimer = this.wvf.LastSlide.SlideInterval;
            slideIntervalTime = (this.wvf.LastSlide.SlideInterval - 1) * 1000;
        }
        else {
            slideTimer = (this.wvf.Slides[this.wvf.CurrentSlide].SlideInterval);
            slideIntervalTime = (this.wvf.Slides[this.wvf.CurrentSlide].SlideInterval - 1) * 1000;
        }

        // Pagination for MM Game Type
        if ((this.selectedGame[0].underlyingRule.GameType == 1 && this.gameState.DisplayOption == 0) || ((this.selectedGame[0].underlyingRule.GameType == 6 || this.selectedGame[0].underlyingRule.GameType == 7) && this.gameState.DisplayOption == 0)) {
            // Default pagesize for MM
            if (this.selectedGame[0].underlyingRule.GameType == 1)
                this.pageSize = 10;
            else if (this.selectedGame[0].underlyingRule.GameType == 6 || this.selectedGame[0].underlyingRule.GameType == 7 && this.gameState.DisplayOption == 0)
                this.pageSize = 16;

            if (this.participantsInfo && this.participantsInfo.length > this.pageSize) {
                this.totalPages = Math.ceil(this.participantsInfo.length / this.pageSize);

                calculatedInterval = ((slideTimer / this.totalPages) * 1000) - 1000;

                // Agreed on a minimum of 3 seconds per page
                if (calculatedInterval < 3000) {
                    calculatedInterval = 3000;
                    slideIntervalTime = (calculatedInterval * this.totalPages);

                    if (this.wvf.Slides[verifyNextSlide ? this.wvf.NextSlide : this.wvf.CurrentSlide])
                        this.wvf.Slides[verifyNextSlide ? this.wvf.NextSlide : this.wvf.CurrentSlide].SlideInterval = slideIntervalTime / 1000;

                    if (this.wvf.LastSlide)
                        this.wvf.LastSlide.SlideInterval = slideIntervalTime / 1000;
                }
            }
            else
                this.currentPage = 0;
        }
        else if (this.selectedGame[0].underlyingRule.GameType == 1 && this.gameState.DisplayOption == 1) {
            // Default pagesize for MM
            this.currentPage = 0;
            this.pageSize = 10;
        }

        if ((this.selectedGame[0].underlyingRule.GameType == 3 && this.gameState.DisplayOption == 0) || (this.selectedGame[0].underlyingRule.GameType == 5 && this.gameState.DisplayOption == 0)) {
            this.pageSize = 5;
            let currentGame = this.selectedGame[0].underlyingRule.GameType == 3 ? this.bullseyeWinners : this.milestoneWinners;
            let maxIndex = currentGame.map((gameItem, index) => { return index }).sort((prevIndex, currIndex) => { return currentGame[currIndex].length - currentGame[prevIndex].length })[0];

            if (currentGame[maxIndex].length > this.pageSize) {
                this.totalPages = Math.ceil(currentGame[maxIndex].length / this.pageSize);

                calculatedInterval = ((slideTimer / this.totalPages) * 1000);

                // Agreed on a minimum of 3 seconds per page
                if (calculatedInterval < 3000) {
                    calculatedInterval = 3000;
                    slideIntervalTime = calculatedInterval * this.totalPages;

                    if (verifyNextSlide)
                        this.wvf.Slides[this.wvf.NextSlide].SlideInterval = slideIntervalTime / 1000;
                    else if (this.wvf.LastSlide != null)
                        slideIntervalTime = (this.wvf.LastSlide.SlideInterval - 1) * 1000;
                    else
                        this.wvf.Slides[this.wvf.CurrentSlide].SlideInterval = slideIntervalTime / 1000;
                }
            }
            else
                this.currentPage = 0;
        }

        if (this.firstSlide)
            this.wvf.FirstSlideReady = true;
        else
            this.wvf.NextSlideReady = true;

        if (this.wvf.RunSlide) {
            // End data updates
            if (this.updateTimerRef != null)
                clearInterval(this.updateTimerRef);

            // Check pagination
            if (calculatedInterval != null && this.totalPages > 0) {
                for (let i = 0; i < this.totalPages; i++) {
                    this.runPagination(calculatedInterval, i)
                }
            }

        }
        else {
            //start pre-load update
            if (!this.updateTimerRef) {
                // Reload the data every 10 secs.
                this.updateTimerRef = setInterval(() => {
                    if (!this.wvf.RunSlide)
                        this.loadGamesHistory(false);
                }, WallboardViewService.HISTORICAL_DATA_REFRESH_INTERVAL);
            }

            setTimeout(() => {
                this.runSlide();
            }, 1000);
        }
    }

    public loadGamesHistory(firstTime: Boolean) {
        if (this.isDestroyed)
            return;

        let ruleID = this.selectedGame[0].underlyingRule.RuleID;
        let selectedStartDate = this.selectedGame[0].Intervals[0].StartDate;
        let selectedEndDate = this.selectedGame[0].Intervals[0].EndDate;

        let participants = null;

        this.isSlideDataLoading = true;

        // Sort rewards of Milestone
        if (this.selectedGame[0].underlyingRule.GameType == 5)
            this.selectedGame[0].MilestoneRewards.sort((a, b) => { return (a.RuleLevelID < b.RuleLevelID) ? 1 : -1 });

        // Just to check if connect 3 will require a free space in the middle
        if ((this.selectedGame[0].underlyingRule.GameType == 6 || this.selectedGame[0].underlyingRule.GameType == 7) && this.selectedGame[0].Connect3Positions.length == 8)
            this.selectedGame[0].Connect3Positions.splice(4, 0, { position: 4, metric: { abbrev: "Free Space", name: "Free Space", metricID: -1, target: null } });

        this.uniqueMilestoneParticipantsIDs = [];

        // Reset winners arrays before processing to prevent duplicate counts on refresh
        this.bullseyeWinners = [[], [], [], [], []];
        this.milestoneWinners = [[], [], [], [], []];

        // Get all the participants by Rule and Interval
        return this.cvApiService.get(`/api/v1/gamification/game/${ruleID}/participants?start=${selectedStartDate}&end=${selectedEndDate}`).then((response) => {
            if (this.isDestroyed) return;
            if (this.wvf.RunSlide && !firstTime) return;


            this.participantsInfo = null;

            // Avoiding duplicated participants
            participants = (response.data as Array<any>).filter((currentElement, index, selfArray) => {
                return index === selfArray.findIndex((t) => {
                    return t.participant.LoginID === currentElement.participant.LoginID;
                });
            });

            participants.forEach(participantObject => {
                // Verifying if user has joined the game
                if (!participantObject.participant.AlreadyJoined) {
                    participantObject.metric = 0;
                    // Uncomment for debugging
                    //participantObject.metric = Math.floor(Math.random() * 101);
                    participantObject.qualifier = 0;
                    participantObject.passed = false;
                    participantObject.results = 'No Results';
                    participantObject.calculatedCoins = 0;
                    participantObject.calculatedXP = 0;
                    participantObject.badges = [];

                    if (this.selectedGame[0].underlyingRule.GameType == 6 || this.selectedGame[0].underlyingRule.GameType == 7)
                        participantObject.connect3Metrics = [];

                    return;
                }

                // Initializing letiables
                participantObject.calculatedCoins = 0;
                participantObject.calculatedXP = 0;
                participantObject.badges = [];

                // To Get Metric and Qualifier per participant.
                if (participantObject.ruleObject.MyRankingObj && participantObject.ruleObject.MyRankingObj.MetricGroupInfos) {
                    if (this.selectedGame[0].Qualifier) {
                        let Qualifier = participantObject.ruleObject.MyRankingObj.MetricGroupInfos.filter((a) => {
                            return a.MetricID === this.selectedGame[0].Qualifier.metricID;
                        })[0];

                        participantObject.qualifier = Qualifier
                            ? this.formatterMetricData(this.selectedGame[0].Qualifier.conversionType, Qualifier.MyMetricValue)
                            : this.formatterMetricData(this.selectedGame[0].Qualifier.conversionType, 0);
                        participantObject.passed = this.isQualified(this.selectedGame[0], Qualifier.MyMetricValue ? Qualifier.MyMetricValue : 0);
                    }
                    else {
                        participantObject.qualifier = 0;
                        participantObject.passed = false;
                    }

                    if (this.selectedGame[0].underlyingRule.GameType == 6 || this.selectedGame[0].underlyingRule.GameType == 7) {
                        participantObject.connect3Metrics = [];

                        // Reset metricCompleted array for each participant to prevent stale data
                        this.metricCompleted = [];

                        // Sort the Positions
                        this.selectedGame[0].Connect3Positions.sort((a, b) => {
                            return (a.position > b.position) ? 1 : -1;
                        });

                        for (let metricPosition of this.selectedGame[0].Connect3Positions) {
                            let metric = participantObject.ruleObject.MyRankingObj.MetricGroupInfos.filter((a) => {
                                return a.MetricID === metricPosition.metric.metricID;
                            })[0];

                            if (metric) {
                                metric.metricCompleted = false;
                                participantObject.connect3Metrics.push(metric);
                            }
                            else {
                                metric = { MetricID: metricPosition.metric.metricID, MyMetricValue: 0, metricCompleted: false };
                                participantObject.connect3Metrics.push(metric);
                            }

                            // Free Space = true
                            if (metricPosition.metric.metricID == -1) {
                                this.metricCompleted[metricPosition.position] = true;
                                participantObject.connect3Metrics[metricPosition.position] = true;
                            }

                            if (metricPosition.metric != null && metricPosition.metric.metricID > -1 && metric != null) {
                                this.metricCompleted[metricPosition.position] = metricPosition.targetObj.Direction == 0
                                    ? metric.MyMetricValue <= metricPosition.targetObj.Target
                                    : metric.MyMetricValue >= metricPosition.targetObj.Target;
                                participantObject.connect3Metrics[metricPosition.position].metricCompleted = this.metricCompleted[metricPosition.position];
                            }
                        }

                        let isConnect3 = this.selectedGame[0].underlyingRule.GameType == 6;
                        if (this.selectedGame[0].Qualifier) {
                            if (participantObject.passed) {
                                let isWinner = isConnect3
                                    ? this.isWinnerConnect3(this.metricCompleted, this.gmf.data.winCasesConnect3)
                                    : this.isWinnerBlackout(this.metricCompleted, this.gmf.data.winCasesBlackout);
                                //participantObject.results = isConnect3 ? (isWinner ? "Connect3" : "No Connections") : (isWinner ? "ConnectAll" : "Not All Connected");
                                participantObject.results = isWinner;

                                // Rewards
                                if (isWinner) {
                                    participantObject.calculatedCoins = isConnect3
                                        ? this.selectedGame[0].Connect3Rewards.ThreeInRow.coins
                                        : this.selectedGame[0].Connect3Rewards.Blackout.coins;
                                    participantObject.calculatedXP = isConnect3
                                        ? this.selectedGame[0].Connect3Rewards.ThreeInRow.xp
                                        : this.selectedGame[0].Connect3Rewards.Blackout.xp;
                                    participantObject.badgeStringImage = isConnect3
                                        ? (this.selectedGame[0].Connect3Rewards.ThreeInRow.badge
                                            ? `<img src="../Admin/ImageResizer.aspx?imgid=${this.selectedGame[0].Connect3Rewards.ThreeInRow.badge}&w=70&h=70" class="img-fluid" />`
                                            : '---')
                                        : (this.selectedGame[0].Connect3Rewards.Blackout.badge
                                            ? `<img src="../Admin/ImageResizer.aspx?imgid=${this.selectedGame[0].Connect3Rewards.Blackout.badge}&w=70&h=70" class="img-fluid" />`
                                            : '---');
                                    participantObject.badges = isConnect3
                                        ? (this.selectedGame[0].Connect3Rewards.ThreeInRow.badge
                                            ? [this.selectedGame[0].Connect3Rewards.ThreeInRow.badge]
                                            : [])
                                        : (this.selectedGame[0].Connect3Rewards.Blackout.badge
                                            ? [this.selectedGame[0].Connect3Rewards.Blackout.badge]
                                            : []);
                                }
                            }
                            else
                                participantObject.results = 'Disqualified';
                        }
                        else {
                            let isWinner = isConnect3
                                ? this.isWinnerConnect3(this.metricCompleted, this.gmf.data.winCasesConnect3)
                                : this.isWinnerBlackout(this.metricCompleted, this.gmf.data.winCasesBlackout);
                            //participantObject.results = isConnect3 ? (isWinner ? "Connect3" : "No Connections") : (isWinner ? "ConnectAll" : "Not All Connected");
                            participantObject.results = isWinner;

                            if (isWinner) {
                                participantObject.calculatedCoins = isConnect3
                                    ? this.selectedGame[0].Connect3Rewards.ThreeInRow.coins
                                    : this.selectedGame[0].Connect3Rewards.Blackout.coins;
                                participantObject.calculatedXP = isConnect3
                                    ? this.selectedGame[0].Connect3Rewards.ThreeInRow.xp
                                    : this.selectedGame[0].Connect3Rewards.Blackout.xp;
                                participantObject.badgeStringImage = isConnect3
                                    ? (this.selectedGame[0].Connect3Rewards.ThreeInRow.badge
                                        ? `<img src="../Admin/ImageResizer.aspx?imgid=${this.selectedGame[0].Connect3Rewards.ThreeInRow.badge}&w=70&h=70" class="img-fluid" />`
                                        : '---')
                                    : (this.selectedGame[0].Connect3Rewards.Blackout.badge
                                        ? `<img src="../Admin/ImageResizer.aspx?imgid=${this.selectedGame[0].Connect3Rewards.Blackout.badge}&w=70&h=70" class="img-fluid" />`
                                        : '---');
                                participantObject.badges = isConnect3
                                    ? (this.selectedGame[0].Connect3Rewards.ThreeInRow.badge
                                        ? [this.selectedGame[0].Connect3Rewards.ThreeInRow.badge]
                                        : [])
                                    : (this.selectedGame[0].Connect3Rewards.Blackout.badge
                                        ? [this.selectedGame[0].Connect3Rewards.Blackout.badge]
                                        : []);
                            }
                        }
                    }
                    else {
                        participantObject.metric = participantObject.metricsValues?.[0]?.MetricDisplayValue
                            || (participantObject.metricsValues?.[0]?.MetricValue != null
                                ? this.formatterMetricData(this.selectedGame[0].SelectedMetrics[0].conversionType, participantObject.metricsValues[0].MetricValue)
                                : 0);

                        if (this.selectedGame[0].Qualifier) {
                            if (participantObject.passed) {
                                let resultObject: any = this.getWinnerRank(this.selectedGame[0], this.selectedGame[0].underlyingRule.GameType, participantObject);
                                participantObject.results = resultObject.result;

                                participantObject.calculatedCoins = resultObject.gameReward && resultObject.gameReward.Coins
                                    ? resultObject.gameReward.Coins.rewardValue
                                    : 0;
                                participantObject.calculatedXP = resultObject.gameReward && resultObject.gameReward.XP
                                    ? resultObject.gameReward.XP.rewardValue
                                    : 0;
                                participantObject.badgeStringImage = resultObject.gameReward && resultObject.gameReward.Badge && resultObject.gameReward.Badge.rewardValue
                                    ? `<img src="../Admin/ImageResizer.aspx?imgid=${resultObject.gameReward.Badge.rewardValue}&w=24&h=24" class="img-fluid" />`
                                    : '---';
                                participantObject.badges = resultObject.gameReward && resultObject.gameReward.Badge && resultObject.gameReward.Badge.rewardValue
                                    ? (this.selectedGame[0].underlyingRule.GameType == 5
                                        ? resultObject.gameReward.Badge.rewardValue
                                        : [resultObject.gameReward.Badge.rewardValue])
                                    : [];
                            }
                            else
                                participantObject.results = 'Disqualified';
                        }
                        else {
                            let resultObject: any = this.getWinnerRank(this.selectedGame[0], this.selectedGame[0].underlyingRule.GameType, participantObject);
                            participantObject.results = resultObject.result;

                            participantObject.calculatedCoins = resultObject.gameReward && resultObject.gameReward.Coins
                                ? resultObject.gameReward.Coins.rewardValue
                                : 0;
                            participantObject.calculatedXP = resultObject.gameReward && resultObject.gameReward.XP
                                ? resultObject.gameReward.XP.rewardValue
                                : 0;
                            participantObject.badgeStringImage = resultObject.gameReward && resultObject.gameReward.Badge && resultObject.gameReward.Badge.rewardValue
                                ? `<img src="../Admin/ImageResizer.aspx?imgid=${resultObject.gameReward.Badge.rewardValue}&w=24&h=24" class="img-fluid" />`
                                : '---';
                            participantObject.badges = resultObject.gameReward && resultObject.gameReward.Badge && resultObject.gameReward.Badge.rewardValue
                                ? (this.selectedGame[0].underlyingRule.GameType == 5
                                    ? resultObject.gameReward.Badge.rewardValue
                                    : [resultObject.gameReward.Badge.rewardValue])
                                : [];
                        }
                    }
                }
                else {
                    participantObject.metric = 0;
                    participantObject.qualifier = 0;
                    participantObject.passed = false;
                    participantObject.results = false;
                }
            });

            this.totalParticipants = participants.length;
            this.nonqualifiedParticipants = participants;

            let participantsValidated = participants.filter((participantItem) => {
                if (this.selectedGame[0].Qualifier) {
                    if (this.selectedGame[0].underlyingRule.GameType == 6 || this.selectedGame[0].underlyingRule.GameType == 7) {
                        if (participantItem.participant.AlreadyJoined === true && participantItem.results) {
                            this.selectedGame[0].Connect3Positions.forEach((metricPosition) => {
                                if (participantItem.connect3Metrics[metricPosition.position].metricCompleted) {
                                    if (metricPosition.numberOfAgents == undefined)
                                        metricPosition.numberOfAgents = 0;

                                    metricPosition.numberOfAgents += 1;
                                }
                            });
                        }

                        return participantItem.participant.AlreadyJoined === true && participantItem.passed && participantItem.results;
                    }
                    else if (this.selectedGame[0].underlyingRule.GameType == 2)
                        return participantItem.participant.AlreadyJoined === true && participantItem.passed && participantItem.results;
                    else
                        return participantItem.participant.AlreadyJoined === true && participantItem.passed;
                }
                else {
                    if (this.selectedGame[0].underlyingRule.GameType == 6 || this.selectedGame[0].underlyingRule.GameType == 7) {
                        if (participantItem.participant.AlreadyJoined === true && participantItem.results) {
                            this.selectedGame[0].Connect3Positions.forEach((metricPosition) => {
                                if (participantItem.connect3Metrics[metricPosition.position].metricCompleted) {
                                    if (metricPosition.numberOfAgents == undefined)
                                        metricPosition.numberOfAgents = 0;

                                    metricPosition.numberOfAgents += 1;
                                }
                            });
                        }

                        return participantItem.participant.AlreadyJoined === true && participantItem.results;
                    }
                    else if (this.selectedGame[0].underlyingRule.GameType == 2)
                        return participantItem.participant.AlreadyJoined === true && participantItem.results;
                    else
                        return participantItem.participant.AlreadyJoined === true;
                }
            });

            this.participantsInfo = [];
            // Scroll Through Pages option in Games Settins
            if (this.selectedGame[0].underlyingRule.GameType == 1) {
                participantsValidated.sort((a, b) => {
                    // Order inverted from high to low
                    return (a.ruleObject.MyRankingObj.MetricGroupInfos[0]?.MyScore > b.ruleObject.MyRankingObj.MetricGroupInfos[0]?.MyScore) ? -1 : 1;
                });

                this.participantsInfo = participantsValidated;
            }
            else if (this.selectedGame[0].underlyingRule.GameType == 2) {
                if (this.selectedGame[0].SelectedMetrics[0].direction == 1) {
                    participantsValidated.sort((a, b) => {
                        // Order inverted from high to low
                        return (a.ruleObject.MyRankingObj.MetricGroupInfos[0]?.MyScore > b.ruleObject.MyRankingObj.MetricGroupInfos[0]?.MyScore) ? -1 : 1;
                    });
                }
                else {
                    // Direction 0 isDownwards
                    participantsValidated.sort((a, b) => {
                        // From low to high
                        return (a.ruleObject.MyRankingObj.MetricGroupInfos[0]?.MyScore > b.ruleObject.MyRankingObj.MetricGroupInfos[0]?.MyScore) ? 1 : -1;
                    });
                }

                this.participantsInfo = participantsValidated;
            }
            else
                this.participantsInfo = participantsValidated;

            this.totalJoinedParticipants = participants.filter((participantItem) => { return participantItem.participant.AlreadyJoined === true; }).length;

            this.isSlideDataLoading = false;
        }).catch((err) => {
            console.log(err)
        });
    }

    public runPagination(interval, index) {
        setTimeout(() => {
            this.currentPage = index == 0 ? 0 : this.currentPage + 1;
        }, index * interval);
    }

    public getWinnerRank(game, gameType, participant) {
        switch (gameType) {
            case 1: {
                let result: string | boolean = 'No Results';

                let gameReward = {
                    Coins: {
                        rewardValue: game.MultiplierMadnessRewards.hasMaxCoins && (game.MultiplierMadnessRewards.coins * participant.ruleObject.MyRankingObj.Score) > game.MultiplierMadnessRewards.maxCoinsPayout ? game.MultiplierMadnessRewards.maxCoinsPayout : game.MultiplierMadnessRewards.coins * participant.ruleObject.MyRankingObj.Score,
                    },
                    XP: {
                        rewardValue: game.MultiplierMadnessRewards.hasMaxXP && (game.MultiplierMadnessRewards.xp * participant.ruleObject.MyRankingObj.Score) > game.MultiplierMadnessRewards.maxXpPayout ? game.MultiplierMadnessRewards.maxXpPayout : game.MultiplierMadnessRewards.xp * participant.ruleObject.MyRankingObj.Score,
                    }
                };

                return { result: result, gameReward: gameReward };
            }
            case 2: { // TopDog
                let result: string | boolean = 'No Results';
                let gameReward;

                game.TopDogRewards.forEach((reward, index) => {
                    let isWinnerTD = this.isWinnerTopDog(game, index, participant.ruleObject);

                    if (isWinnerTD) {
                        result = isWinnerTD;
                        gameReward = reward;
                    }
                });

                return { result: result, gameReward: gameReward };
            }
            case 3: { // Bullseye
                let result: string | boolean = 'No Results';
                let gameReward;

                // Find the BEST (first matching) tier only - don't continue to lower tiers
                for (let index = 0; index < game.BullseyeRewards.length; index++) {
                    const reward = game.BullseyeRewards[index];
                    let isWinnerBe = this.isWinnerBullseye(game, index, participant.ruleObject);
                    if (isWinnerBe) {
                        result = isWinnerBe;
                        gameReward = reward;
                        this.bullseyeWinners[index].push(participant);
                        break; // Stop after finding the best tier - participant belongs to only ONE tier
                    }
                }

                return { result: result, gameReward: gameReward }
            }
            case 5: { // Milestone
                let result: string | boolean = 'No Results';
                let gameReward = null;
                let length = game.MilestoneRewards.length;

                let sumCoins = { rewardValue: 0 };
                let sumXP = { rewardValue: 0 };
                let arrBadges = { rewardValue: [] };

                game.MilestoneRewards.slice().reverse().forEach((reward, index) => {
                    let reversedIndex = game.MilestoneRewards.length - index - 1;
                    let isWinnerMi = this.isWinnerMilestone(game, reversedIndex, participant.ruleObject);

                    if (isWinnerMi) {
                        result = 'Milestone ' + (reversedIndex + 1);

                        sumCoins.rewardValue += reward.Coins.rewardValue;
                        sumXP.rewardValue += reward.Coins.rewardValue;
                        if (reward.Badge && reward.Badge.rewardValue)
                            arrBadges.rewardValue.push(reward.Badge.rewardValue);

                        if (this.uniqueMilestoneParticipantsIDs.indexOf(participant.participant.LoginID) === -1) {
                            this.milestoneWinners[reversedIndex].push(participant);
                            this.uniqueMilestoneParticipantsIDs.push(participant.participant.LoginID);
                        }
                    }
                });

                gameReward = {
                    XP: sumCoins,
                    Coins: sumXP,
                    Badge: arrBadges
                };

                return { result: result, gameReward: gameReward };
            }
        }
    }

    public isWinnerTopDog(gamedata, index, gameranking) {
        if (gameranking == undefined || gameranking == null
            || gameranking.MyRankingObj == null || gameranking.MyRankingObj.MetricGroupInfos == undefined
            || gameranking.MyRankingObj.MetricGroupInfos == null)
            return "";

        // Check if the game has qualifier metric
        if (gamedata.Qualifier != null && gameranking.MyRankingObj.MetricGroupInfos.length > 1) {
            if (gameranking.MyRankingObj.MyRanking == (index + 1) && this.isQualified(gamedata, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue))
                return this.getLocalizedTierText(gameranking.MyRankingObj.MyRanking, 2);
        }
        else {
            // The game doesn't have qualifier metric
            if (gameranking.MyRankingObj.MyRanking == (index + 1))
                return this.getLocalizedTierText(gameranking.MyRankingObj.MyRanking, 2);
        }
    }

    public isWinnerBullseye(game, index, gameranking) {
        if (gameranking == undefined || gameranking == null || gameranking.MyRankingObj == undefined || gameranking.MyRankingObj == null)
            return "";

        // Use the actual metric value from MetricGroupInfos[0], NOT Score (which is always 0)
        let metricValue = gameranking.MyRankingObj.MetricGroupInfos?.[0]?.MyMetricValue ?? 0;

        let minValue = game.BullseyeRewards[index].Target.Val1;
        let maxValue = game.BullseyeRewards[index].Target.Val2;

        const qualifierMetricValue = game.Qualifier
            ? (gameranking.MyRankingObj.MetricGroupInfos?.find((m) => m.MetricID === game.Qualifier.metricID)?.MyMetricValue ?? 0)
            : 0;

        switch (game.BullseyeRewards[index].ComparisonType) {
            case 1: // Greater than
                // Check if the game has qualifier
                if (game.Qualifier != null) {
                    if (metricValue >= minValue && this.isQualified(game, qualifierMetricValue))
                        return true; //getLocalizedTierText(index + 1, 3);
                }
                else {
                    if (metricValue >= minValue)
                        return true; //getLocalizedTierText(index + 1, 3);
                }
                break;
            case 2: // Less than
                // Check if the game has qualifier
                if (game.Qualifier != null) {
                    if (metricValue <= minValue && this.isQualified(game, qualifierMetricValue))
                        return true;//getLocalizedTierText(index + 1, 3);
                }
                else {
                    if (metricValue <= minValue)
                        return true;//getLocalizedTierText(index + 1, 3);
                }
                break;
            case 3: // Between
                // Prepare letiables for comparing process
                if (game.SelectedMetrics[0].direction == "1") { // Up Metrics
                    if (game.Qualifier != null) {
                        if (metricValue >= minValue && metricValue <= maxValue && this.isQualified(game, qualifierMetricValue))
                            return true;
                    }
                    else {
                        if (metricValue >= minValue && metricValue <= maxValue)
                            return true;
                    }
                }
                else {
                    if (game.Qualifier != null) {
                        if (metricValue >= Math.min(minValue, maxValue) && metricValue <= Math.max(minValue, maxValue) && this.isQualified(game, qualifierMetricValue))
                            return true;
                    }
                    else {
                        if (metricValue >= Math.min(minValue, maxValue) && metricValue <= Math.max(minValue, maxValue))
                            return true;
                    }
                }
                break;
            default:
                break;
        }

        return false;
    }

    public getLocalizedTierText(tier, gameType) {
        // if gameType :
        switch (tier) {
            case 1:
                if (gameType == 2) // TopDog
                    return 'topDogRank1';
                else if (gameType == 3) // Bullseye
                    return this.gmf.getLocalizedMessage("Ring_Prize", "Bullseye");
                break;
            case 2:
                if (gameType == 2) // TopDog
                    return 'topDogRank2';
                else if (gameType == 3) // Bullseye
                    return this.gmf.getLocalizedMessage("2nd_Ring", "2nd Ring");
                break;
            case 3: // Bullseye
                if (gameType == 2) // TopDog
                    return 'topDogRank3';
                else if (gameType == 3) // Bullseye
                    return this.gmf.getLocalizedMessage("3rd_Ring", "3rd Ring");
                break;
            default:
                let number = tier + this.gmf.getLocalizedMessage("Th_Symbol", "th") + " ";
                if (gameType == 2) { // TopDog
                    //number += gamesFactory.getLocalizedMessage("Place", "Place");
                    if (tier == 4) return 'topDogRank4';
                    if (tier == 5) return 'topDogRank5';
                }
                else if (gameType == 3) // Bullseye
                    number += this.gmf.getLocalizedMessage("Ring", "Ring");
                return number;
            // Add the next type of games
        }

        return "";
    }

    public isQualified(game, myValue) {
        if (!game || !game.Qualifier)
            return false;

        let isQualified = false;

        switch (game.QualifierLevels.comparerType) {
            case 1: // Greater than
                if (myValue > game.QualifierLevels.leftNumber)
                    isQualified = true;
                break;
            case 2: // Less than
                if (myValue < game.QualifierLevels.leftNumber)
                    isQualified = true;
                break;
            case 3: // Between
                if (myValue >= game.QualifierLevels.leftNumber && myValue <= game.QualifierLevels.rightNumber)
                    isQualified = true;
                break;
            default:
                return;
        }

        return isQualified;
    }

    public isWinnerConnect3(metricCompleted, winCasesConnect3) {
        let bin = 0;
        for (let i = 0; i < metricCompleted.length; i++) {
            bin += (metricCompleted[i]) ? Math.pow(2, i) : 0;
        }

        for (let i = 0; i < winCasesConnect3.length; i++) {
            let result = bin & winCasesConnect3[i];
            if (result === winCasesConnect3[i])
                return true;
        }

        return false;
    }

    public isWinnerBlackout(metricCompleted, winCasesBlackout) {
        let bin = 0;
        for (let i = 0; i < metricCompleted.length; i++) {
            bin += (metricCompleted[i]) ? Math.pow(2, i) : 0;
        }

        for (let i = 0; i < winCasesBlackout.length; i++) {
            let result = bin & winCasesBlackout[i];
            if (result === winCasesBlackout[i])
                return true;
        }

        return false;
    }

    public isWinnerMilestone(gamedata, index, gameranking) {
        if (gameranking == undefined || gameranking == null ||
            gameranking.MyRankingObj == undefined || gameranking.MyRankingObj == null) return "";

        if (gameranking.MyRankingObj.MetricGroupInfos && gameranking.MyRankingObj.MetricGroupInfos.length == 0)
            return false;

        // Game has Qualifier
        let isQualifiedFlag = null;
        if (gamedata.Qualifier != null)
            isQualifiedFlag = this.isQualified(gamedata, gameranking.MyRankingObj.MetricGroupInfos[1].MyMetricValue);

        // Prepare letiables for comparing process 
        let metricValue = gameranking.MyRankingObj.MetricGroupInfos[0].MyMetricValue;
        let minValue = gamedata.MilestoneRewards[index].Target.Val1;
        let maxValue = gamedata.MilestoneRewards[index].Target.Val2;
        let isWinner = false;

        if (gamedata.SelectedMetrics[0].direction == "1") { // Up Metrics
            if (gamedata.MilestoneRewards[index].ComparisonType == 1) // Greater than
                isWinner = (metricValue >= minValue);
            else
                isWinner = (metricValue >= maxValue || (metricValue >= minValue && metricValue <= maxValue));
        }
        else { // Down Metrics
            if (gamedata.MilestoneRewards[index].ComparisonType == 2) // Less than
                isWinner = (metricValue <= minValue);
            else
                isWinner = (metricValue <= maxValue || (metricValue <= maxValue && metricValue >= minValue));
        }

        // Game has Qualifier
        if (gamedata.Qualifier != null && isQualifiedFlag && isWinner)
            return true;
        // Game has no Qualifier
        else if (gamedata.Qualifier == null && isQualifiedFlag == null && isWinner)
            return true;

        return false;
    }

    public getConnect3Class(metricPosition, gameType) {
        let metricData = null;

        let classes: any = {};
        if (metricPosition.metric.metricID == -1)
            (gameType == 6) ? classes.freeSpace = true : classes.freeSpaceBlackout = true;
        if (metricPosition.metric == null)
            classes.simpleCard = true;
        if (metricPosition.metric != null && metricPosition.metric.metricID > -1 && metricData == null)
            (gameType == 6) ? classes.cardConfiguredConnect3 = true : classes.cardConfiguredBlackout = true;

        if (metricPosition.metric != null && metricPosition.metric.metricID > -1 && metricData != null) {
            // Verify if the target
            if (metricPosition.targetObj.Direction == 0) {
                // Less than
                if (metricData.MyMetricValue <= metricPosition.targetObj.Target)
                    (gameType == 6) ? classes.cardCompleted = true : classes.cardCompletedBlackout = true;
                else
                    (gameType == 6) ? classes.cardConfiguredConnect3 = true : classes.cardConfiguredBlackout = true;
            }
            else {
                // Greater than
                if (metricData.MyMetricValue >= metricPosition.targetObj.Target)
                    (gameType == 6) ? classes.cardCompleted = true : classes.cardCompletedBlackout = true;
                else
                    (gameType == 6) ? classes.cardConfiguredConnect3 = true : classes.cardConfiguredBlackout = true;
            }

            this.metricCompleted[metricPosition.position] = (classes.cardCompleted || classes.freeSpace || classes.freeSpaceBlackout || classes.cardCompletedBlackout) ? true : false;
        }

        return classes;
    }

    public getCheckmark(index) {
        if (this.selectedGame[0] == null)
            return;

        this.MilestoneThemes = this.gmf.getGameDefinitions().filter((gt) => { return gt.GameType == 5 })[0].Themes;
        this.themeSelected = this.MilestoneThemes[this.selectedGame[0].MilestoneDetails.MilestoneThemeSelected.themeID - 1];

        return { 'background-image': 'url(' + this.themeSelected.themePath + "checkmark" + (index + 1) + ".svg" + ')' };
    }

    //#region Games Module Calculations
    public getBadgeUsingIndex(game, index) {
        let reward = null;

        /*if (game.MultiplierMadnessRewards != null)
            reward = (game.MultiplierMadnessRewards.Badge != null) ? game.MultiplierMadnessRewards.Badge : null;*/

        if (game.TopDogRewards != null) {
            if (game.TopDogRewards.length > index) {
                if (game.TopDogRewards[index].Badge != undefined || game.TopDogRewards[index].Badge != null)
                    reward = game.TopDogRewards[index].Badge.rewardValue
                else
                    reward = null;
            }
        } // Get 1st place reward
        else if (game.BullseyeRewards != null)
            reward = (game.BullseyeRewards.length != 0 && game.BullseyeRewards[index].Badge != null) ? game.BullseyeRewards[index].Badge.rewardValue : null;
        else if (game.MilestoneRewards != null)
            reward = (game.MilestoneRewards.length != 0 && game.MilestoneRewards[index].Badge != null) ? game.MilestoneRewards[index].Badge.rewardValue : null;

        if (reward == null || reward == 0)
            return null;

        return "../Admin/ImageResizer.aspx?imgid=" + reward + "&w=70&h=70";
    }

    public formatterMetricData(conversionType, value) {
        let formatted;
        if (value == undefined || value == null)
            value = 0;

        switch (conversionType) {
            case "1": // Second
                formatted = value;
                break;
            case "2": // Minute
                formatted = value / 60;
                break;
            case "3": // Hour
                formatted = Math.floor((+value / 3600) * 100) / 100;
                break;
            case "4": // Time
                let hours: any = Math.floor(+value / 3600);
                let minutes: any = Math.floor((+value - (hours * 3600)) / 60);
                let seconds: any = +value - (hours * 3600) - (minutes * 60);
                // Cap seconds to a max of 2 decimals to avoid float noise (e.g. 16.00999999999999 -> 16.01)
                seconds = Math.round(seconds * 100) / 100;

                if (hours < 10)
                    hours = "0" + hours;
                if (minutes < 10)
                    minutes = "0" + minutes;
                if (seconds < 10)
                    seconds = "0" + seconds;

                formatted = hours + ':' + minutes + ':' + seconds;
                break;
            case "5": // Percent
                formatted = (value * 100).toFixed(2);
                break;
            default:
                formatted = value;
                break;
        }

        return formatted;
    }
}
//endregion
